export const paopsrSsh = [
  {
    item_nombre: "Programa Anual de Obra Pública y Servicios Relacionados con la Misma",
    item_url: "../contenido/transparencia/paopsr/Programa Anual de Obra Publica 2026 SSH.pdf",
    item_descripcion: "Ejercicio Fiscal 2026"
  }, 
  {
    item_nombre: "Programa Anual de Obra Pública y Servicios Relacionados con la Misma",
    item_url: "../contenido/transparencia/paopsr/Programa Anual de Obra Publica 2025 SSH.pdf",
    item_descripcion: "Ejercicio Fiscal 2025"
  },
  {
    item_nombre: "Programa Anual de Obra Pública y Servicios Relacionados con la Misma",
    item_url: "../contenido/transparencia/paopsr/Programa Anual de Obra Publica 2024 SSH.pdf",
    item_descripcion: "Ejercicio Fiscal 2024"
  },
];